class BannerWithProduct extends HTMLElement {
    constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        this.calculateHeaderHeight();
        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
    }

    calculateHeaderHeight() {
        const headerComponent = document.getElementById('header-component');
        const headerHeight = headerComponent ? headerComponent.offsetHeight : 0;
        this.style.setProperty('--header-height', `${headerHeight}px`);
    }

    handleResize() {
        this.calculateHeaderHeight();
    }
}

if (!customElements.get('banner-with-product')) {
    customElements.define('banner-with-product', BannerWithProduct);
}
